/** Font weight for parent chip when a parent task is selected. */
export const PARENT_CHIP_FONT_WEIGHT_SELECTED = 600;

/** Font weight for parent chip at root level. */
export const PARENT_CHIP_FONT_WEIGHT_ROOT = 400;
